import { createMessage } from '../../index';
import { MessageGroup } from '../../types';

export interface IUpdateBalanceMessagePayload {
  /** A value of actual balance, accounted for total bet and winnings */
  amount: number;
  /** A value of bonus balance, accounted for total bet and winnings */
  bonus: number;
  /** A value of total bet, not to be used in further bonus calculations, but as indicator of a bet present */
  totalBet: number;
}

export const updateBalanceMessage = createMessage<'updateBalance', IUpdateBalanceMessagePayload>('updateBalance', {
  group: MessageGroup.Common,
});
